import Image from 'next/image';
import './index.less';

interface IProps {
  title: string;
  customClass?: string;
  reviewsData: Array<{
    logo?: string;
    title?: string;
    desc?: string[];
    name?: string;
    company?: string;
    comment?: string;
    backgroundImage: string;
    logoStyle?: React.CSSProperties;
  }>;
}

const ReviewsFromOtherBrands = ({ title, reviewsData = [], customClass = '' }: IProps) => {
  return (
    <div className={`retail-connect-reviews-from-other-brands-container ${customClass}`}>
      <div className="retail-connect-reviews-from-other-brands">
        <div className="retail-connect-reviews-from-other-brands-title">{title}</div>
        <div className="retail-connect-reviews-from-other-brands-content-container">
          {reviewsData.map((review, index) => {
            return (
              <div
                key={index}
                className="retail-connect-reviews-from-other-brands-review"
                style={{
                  backgroundImage: `url(${review.backgroundImage})`,
                }}
              >
                {review.logo && (
                  <div className="retail-connect-reviews-from-other-brands-review-logo">
                    <div style={review?.logoStyle}>
                      <Image src={review.logo} fill alt="logo" />
                    </div>
                  </div>
                )}
                {review.title && (
                  <div className="retail-connect-reviews-from-other-brands-review-title">{review.title}</div>
                )}
                {review.desc && (
                  <div className="retail-connect-reviews-from-other-brands-review-desc">
                    {review.desc.map((d) => (
                      <div key={d}>{d}</div>
                    ))}
                  </div>
                )}
                {review.comment && (
                  <>
                    <div className="retail-connect-reviews-from-other-brands-review-content-comment">
                      {review.comment}
                    </div>
                    <div className="retail-connect-reviews-from-other-brands-review-content-name">{review.name}</div>
                    <div className="retail-connect-reviews-from-other-brands-review-content-company">
                      {review.company}
                    </div>
                  </>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ReviewsFromOtherBrands;
